"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Count the occurrences of a particular Tile in an array of Tiles.
 * @param tiles the array of Tile.
 * @param targetTile the Tile of which the number of occurrences has to be counted.
 * @returns {number} occurrence of the targetTile.
 */
function countTilesOccurrences(tiles, targetTile) {
    let result = 0;
    for (const tile of tiles) {
        if (targetTile.isIdentical(tile)) {
            result++;
        }
    }
    return result;
}
exports.default = countTilesOccurrences;
